module.exports = __webpack_public_path__ + "media/customizations/terramor/back-3b9dcdbc78250a94d44638063efab6d7.jpg";